import { QueryKeys } from './common';

export const fabricQueryKeys = {
  orchestrationFabricsToken: (fabricIds: number[]) => [
    QueryKeys.Fabric,
    QueryKeys.OrchestrationFabrics,
    'Token',
    fabricIds
  ]
};
